import { ICondition } from "../../../../vendor_core/core/src/states/State";
import CoinModel from "../../../model/CoinModel";


export default class CRCHasCoinCondition implements ICondition {
    public check(): boolean {
        return CoinModel.hasCoin;
    }
}
